import { useTranslation } from "react-i18next";
import { formatDate } from "../lib/format";

/** Rok koji ističe u naredna tri meseca se označava, da se ta roba pusti prva. */
const USKORO_DANA = 90;

/**
 * Rok isteka LOT-a, sa oznakom kad je prošao („isteklo“) ili je blizu („još N d.“). Isti prikaz je u Magacinu i na
 * strani proizvoda, da se rok čita isto gde god se LOT gleda.
 */
export function LotExpiry({ iso, lang }: { iso: string | null; lang?: string }) {
  const { t } = useTranslation();
  if (!iso) return <>—</>;
  const dana = daniDo(iso);
  return (
    <>
      {/* Datum se ne lomi („19. 9. / 2028.“ se čita kao dva podatka); oznaka sme u sledeći red uske kolone. */}
      <span style={{ whiteSpace: "nowrap" }}>{formatDate(iso, lang)}</span>{" "}
      {dana < 0 ? (
        <span className="tag err">{t("warehouse.expired", "isteklo")}</span>
      ) : dana <= USKORO_DANA ? (
        <span className="tag warn">{t("warehouse.daysLeft", "još {{n}} d.", { n: dana })}</span>
      ) : null}
    </>
  );
}

/** Celih dana od danas do datuma (ISO, bez vremena); negativno kad je prošao. */
export function daniDo(iso: string): number {
  const [g, m, d] = iso.slice(0, 10).split("-").map(Number);
  const danas = new Date();
  const pocetak = Date.UTC(danas.getFullYear(), danas.getMonth(), danas.getDate());
  return Math.round((Date.UTC(g, m - 1, d) - pocetak) / 86_400_000);
}
